import {
  getAccessSnapshot,
  hasCapability,
  hasFullAccessRole,
  readAccessSession,
} from "@/utils/accessControl";

const icon = (paths) =>
  `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${paths}</svg>`;

export const sideMenuItems = [
  {
    id: 0,
    label: "All Companies",
    link: "/companies",
    svg: icon(`
      <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"/>
      <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"/>
      <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"/>
      <path d="M10 6h4"/><path d="M10 10h4"/>
      <path d="M10 14h4"/><path d="M10 18h4"/>
    `),
    acl_name: "all_companies",
    isSuperAdmin: true,
  },
  {
    id: 1,
    label: "Overview",
    link: "/overview",
    svg: icon(`
      <rect width="7" height="9" x="3" y="3" rx="1"/>
      <rect width="7" height="5" x="14" y="3" rx="1"/>
      <rect width="7" height="9" x="14" y="12" rx="1"/>
      <rect width="7" height="5" x="3" y="16" rx="1"/>
    `),
    acl_name: "overview",
    route_name: "OverviewView",
  },
  {
    id: 2,
    label: "Analytics",
    link: "/analytics/engagement",
    svg: icon(`
      <path d="M3 3v18h18"/>
      <path d="M18 17V9"/>
      <path d="M13 17V5"/>
      <path d="M8 17v-3"/>
    `),
    acl_name: "conversations_analytics",
    route_name: "EngagementAnalyticsView",
    children: [
      {
        parentId: 2,
        label: "Conversations",
        link: "/analytics/engagement",
        svg: icon(`<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>`),
        acl_name: "conversations_analytics",
        route_name: "EngagementAnalyticsView",
      },
      {
        parentId: 2,
        label: "Agents",
        link: "/analytics/agents",
        svg: icon(`
          <path d="M12 8V4H8"/>
          <rect width="16" height="12" x="4" y="8" rx="2"/>
          <path d="M2 14h2"/><path d="M20 14h2"/>
          <path d="M15 13v2"/><path d="M9 13v2"/>
        `),
        acl_name: "conversations_analytics",
        route_name: "AgentsAnalyticsView",
      },
      {
        parentId: 2,
        label: "Stocks",
        link: "/analytics/attachments",
        svg: icon(`<path d="m7.5 4.27 9 5.15"/><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/><path d="m3.3 7 8.7 5 8.7-5"/><path d="M12 22V12"/>`),
        acl_name: "conversations_analytics",
        route_name: "AttachmentsBoardView",
      },
      {
        parentId: 2,
        label: "Devices",
        link: "/analytics/devices",
        svg: icon(`
          <rect width="20" height="14" x="2" y="3" rx="2"/>
          <path d="M8 21h8"/>
          <path d="M12 17v4"/>
        `),
        acl_name: "conversations_analytics",
        route_name: "DevicesAnalyticsView",
      },
      {
        parentId: 2,
        label: "Cart Activity",
        link: "/analytics/cart",
        svg: icon(`<circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>`),
        acl_name: "conversations_analytics",
        route_name: "CartAnalyticsView",
      },
    ],
  },
  {
    id: 3,
    label: "Sites & Devices",
    link: "/sites-devices",
    svg: icon(`
      <rect width="20" height="14" x="2" y="3" rx="2"/>
      <path d="M8 21h8"/>
      <path d="M12 17v4"/>
    `),
    acl_name: "sites_and_devices",
    route_name: "SitesAndDevicesView",
  },
  {
    id: 4,
    label: "Knowledge Base",
    svg: icon(`
      <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
      <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
    `),
    children: [
      {
        parentId: 4,
        label: "Data Library",
        link: "/data-library",
        svg: icon(`
          <path d="M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"/>
        `),
        acl_name: "data_library",
        route_name: "DataLibraryView",
      },
      {
        parentId: 4,
        label: "Data Source",
        link: "/data-source",
        svg: icon(`
          <ellipse cx="12" cy="5" rx="9" ry="3"/>
          <path d="M3 5V19A9 3 0 0 0 21 19V5"/>
          <path d="M3 12A9 3 0 0 0 21 12"/>
        `),
        acl_name: "data_source",
        route_name: "DataSourceView",
      },
      {
        parentId: 4,
        label: "Integrations",
        link: "/integrations",
        svg: icon(`
          <rect x="16" y="16" width="6" height="6" rx="1"/>
          <rect x="2" y="16" width="6" height="6" rx="1"/>
          <rect x="9" y="2" width="6" height="6" rx="1"/>
          <path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3"/>
          <path d="M12 12V8"/>
        `),
        acl_name: "integrations",
        route_name: "IntegrationsView",
      },
      {
        parentId: 4,
        label: "Jobs",
        link: "/jobs",
        svg: icon(`
          <rect width="20" height="14" x="2" y="7" rx="2"/>
          <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
        `),
        acl_name: "jobs",
        route_name: "JobsView",
      },
    ],
  },
  {
    id: 5,
    label: "Agents Management",
    svg: icon(`
      <path d="M12 8V4H8"/>
      <rect width="16" height="12" x="4" y="8" rx="2"/>
      <path d="M2 14h2"/>
      <path d="M20 14h2"/>
      <path d="M15 13v2"/>
      <path d="M9 13v2"/>
    `),
    acl_name: "agents_management",
    route_name: "AgentsView",
    children: [
      {
        parentId: 5,
        label: "Agents List",
        link: "/agents-management",
        svg: icon(`
          <path d="M12 8V4H8"/>
          <rect width="16" height="12" x="4" y="8" rx="2"/>
          <path d="M2 14h2"/>
          <path d="M20 14h2"/>
          <path d="M15 13v2"/>
          <path d="M9 13v2"/>
        `),
        acl_name: "agents_management",
        route_name: "AgentsView",
      },
      {
        parentId: 5,
        label: "Agents Test",
        link: "/agents-test",
        svg: icon(`
          <path d="M10 2v7.31"/>
          <path d="M14 9.3V1.99"/>
          <path d="M8.5 2h7"/>
          <path d="M14 9.3a6.5 6.5 0 1 1-4 0"/>
          <path d="M5.52 16h12.96"/>
        `),
        acl_name: "test_agent",
        route_name: "TestAgentView",
      },
      {
        parentId: 5,
        label: "Agent Instructions",
        link: "/agents-instructions",
        svg: icon(`
          <rect width="8" height="4" x="8" y="2" rx="1" ry="1"/>
          <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
          <path d="M12 11h4"/>
          <path d="M12 16h4"/>
          <path d="M8 11h.01"/>
          <path d="M8 16h.01"/>
        `),
        acl_name: "prompts_instructions",
        route_name: "AgentInstructionsView",
      },
    ],
  },
  {
    id: 6,
    label: "Configurations",
    svg: icon(`
      <path d="M20 7h-9"/>
      <path d="M14 17H5"/>
      <circle cx="17" cy="17" r="3"/>
      <circle cx="7" cy="7" r="3"/>
    `),
    acl_name: "configurations_management",
    route_name: "ConfigurationsView",
    children: [
      {
        parentId: 6,
        label: "Device Configurations",
        link: "/configurations",
        svg: icon(`
          <path d="M20 7h-9"/>
          <path d="M14 17H5"/>
          <circle cx="17" cy="17" r="3"/>
          <circle cx="7" cy="7" r="3"/>
        `),
        acl_name: "configurations",
        route_name: "ConfigurationsView",
      },
      {
        parentId: 6,
        label: "Themes",
        link: "/themes",
        svg: icon(`
          <circle cx="13.5" cy="6.5" r=".5" fill="currentColor"/>
          <circle cx="17.5" cy="10.5" r=".5" fill="currentColor"/>
          <circle cx="8.5" cy="7.5" r=".5" fill="currentColor"/>
          <circle cx="6.5" cy="12.5" r=".5" fill="currentColor"/>
          <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z"/>
        `),
        acl_name: "themes",
        route_name: "ThemesView",
      },
      {
        parentId: 6,
        label: "Media Library",
        link: "/media-library",
        svg: icon(`
          <rect width="18" height="18" x="3" y="3" rx="2" ry="2"/>
          <circle cx="9" cy="9" r="2"/>
          <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/>
        `),
        acl_name: "media_library",
        route_name: "MediaLibraryView",
      },
      {
        parentId: 6,
        label: "Campaigns",
        link: "/campaigns",
        svg: icon(`
          <path d="m3 11 18-5v12L3 14v-3z"/>
          <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"/>
        `),
        acl_name: "campaigns",
        route_name: "CampaignsView",
      },
    ],
  },
  {
    id: 7,
    label: "Users",
    link: "/users",
    svg: icon(`
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
      <circle cx="9" cy="7" r="4"/>
      <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    `),
    acl_name: "users",
    route_name: "UsersView",
  },
];

// Same visibility rule SidebarNavigation applies: super-admins and
// multi-company users see everything; single-company users only see
// non-superadmin-only items.
export function shouldShowMenuItem(item, userDetails, superAdminEmail) {
  const session = { ...readAccessSession(), userDetails };

  // Owner / admin / super-admin / operator all get the full menu, regardless of
  // what the backend put in their grant set — a role of this kind with empty
  // permissions must not collapse to an empty sidebar. `isSuperAdmin`-only items
  // stay restricted to the super-admin account and multi-company users, since
  // those are cross-company views rather than a capability.
  if (hasFullAccessRole(session)) {
    return isSuperAdminItemVisible(item, userDetails, superAdminEmail);
  }

  const { hasExplicitGrants } = getAccessSnapshot(session);
  if (hasExplicitGrants) {
    return Boolean(item.acl_name) &&
      hasCapability(item.acl_name, session, { legacyDefault: false });
  }

  return isSuperAdminItemVisible(item, userDetails, superAdminEmail);
}

// Cross-company entries ("All Companies") are gated on identity, not capability.
function isSuperAdminItemVisible(item, userDetails, superAdminEmail) {
  const email = userDetails?.user?.email;
  const companies = userDetails?.user?.companies;
  const isSuperAdmin =
    (Boolean(superAdminEmail) && email === superAdminEmail) ||
    (companies && companies.length > 1);
  if (isSuperAdmin) return true;
  return !item.isSuperAdmin;
}

export function filterMenuItemsForAccess(items, userDetails, superAdminEmail) {
  return items.flatMap((item) => {
    const childKey = item.subItems ? "subItems" : item.children ? "children" : null;
    const children = childKey
      ? filterMenuItemsForAccess(item[childKey], userDetails, superAdminEmail)
      : [];
    const visible = shouldShowMenuItem(item, userDetails, superAdminEmail);
    if (!visible && children.length === 0) return [];
    return [{ ...item, ...(childKey ? { [childKey]: children } : {}) }];
  });
}

const firstLink = (items) => {
  for (const item of items) {
    if (item.link) return item.link;
    const children = item.subItems || item.children;
    if (children) {
      const found = firstLink(children);
      if (found) return found;
    }
  }
  return null;
};

const firstAccessibleLink = (userDetails, superAdminEmail) => {
  const accessible = filterMenuItemsForAccess(
    sideMenuItems.filter((item) => !item.isSuperAdmin),
    userDetails,
    superAdminEmail,
  );
  return firstLink(accessible);
};

// Post-login / post-company-selection landing page. Sites & Devices stays the
// default (matches legacy sessions and owners, who always pass sites_and_devices
// via the owner bypass in hasCapability), but a team member whose role explicitly
// omits that capability would otherwise be sent straight into the router guard's
// 404 redirect — fall back to their first actually-accessible menu item instead.
export function resolveLandingLink(userDetails, superAdminEmail) {
  const session = { ...readAccessSession(), userDetails };
  const { hasExplicitGrants } = getAccessSnapshot(session);
  if (!hasExplicitGrants || hasCapability("sites_and_devices", session, { legacyDefault: false })) {
    return "/sites-devices";
  }

  return firstAccessibleLink(userDetails, superAdminEmail) || "/sites-devices";
}

// True unless the account has an explicit grant set that (a) omits
// sites_and_devices and (b) omits every other menu capability too — i.e. a role
// with no usable page at all. Used by NotFoundView to tell a genuine dead end
// (nothing this account can open) apart from an ordinary bad link, since
// resolveLandingLink's own fallback would otherwise send that account right
// back into the same guarded route that produced the 404.
export function hasAnyMenuAccess(userDetails, superAdminEmail) {
  const session = { ...readAccessSession(), userDetails };
  const { hasExplicitGrants } = getAccessSnapshot(session);
  if (!hasExplicitGrants || hasCapability("sites_and_devices", session, { legacyDefault: false })) {
    return true;
  }
  return Boolean(firstAccessibleLink(userDetails, superAdminEmail));
}
